var exports = {
  "w": "xa15a2ab7--f8c911--header",
  "H": "xa15a2ab7--f8c911--cell",
  "l": "xa15a2ab7--f8c911--l",
};

module.exports = exports;
